import React, { Component } from "react";
import * as Business from "../../../utils/business";
import * as Http from "../../../http";
import { ButtonToolbar, Button, MenuItem, DropdownButton, ButtonGroup } from "react-bootstrap";
import Loading from "../../../components/Loading";
import { Line } from "react-chartjs-2";
import moment from "moment";
import Alert from 'sweetalert-react';
import "./style.scss";
import {
    CAP_C_CAPITAL_TABLE,
    CAP_C_RWA_TABLE_BOTTOM,
    CAP_C_RWA_TABLE_TOP,
    CAP_S_CAPITAL_TABLE,
    CAP_S_RWA_TABLE_BOTTOM,
    CAP_S_RWA_TABLE_TOP,
    CAR_TABLE
} from "./constants";
import { v4 as uuidv4 } from 'uuid';
import * as ExcelJS from "exceljs/dist/exceljs";
import { ErrorCode, FileExtension } from "../../../const";
import html2canvas from 'html2canvas';

const chunkSize = 1048576 * 3;

class CapPlanningDetail extends Component {
    state = {
        reportName: null,
        capitalScenario: null,
        showConfirmation: false,
        disabledInput: {},
        calculated: false,
        loading: true,
        snapshotDates: [],
        selectedDate: null,
        selectedBank: "HDBANK",
        carTbl: CAR_TABLE,
        capitalTbl: null,
        rwaTblTop: null,
        rwaTblBottom: null,
        sumCapitalAMT: null,
        sumCapitalSecenario: null,
        sumCapitalT1: null,
        sumCapitalT2: null,
        sumCapitalT3: null,
        sumRwaCHG: null,
        sumRwaT1: null,
        sumRwaT2: null,
        sumRwaT3: null,
        totalRwa: null,
        chartLabels: null,
        chartDatasets: [
            {
                label: "BASELINE",
                data: [0, 0, 0, 0],
                borderColor: "rgb(255, 99, 132)"
            },
            {
                label: "SCENARIO",
                data: [0, 0, 0, 0],
                borderColor: "rgb(53, 162, 235)"
            }
        ],
        dicFileToBeUpload: {}
    };

    lineChartOptions = {
        maintainAspectRatio: true,
        scales: {
            yAxes: [
                {
                    min: 0,
                    ticks: {
                        precision: 0,
                        callback: function (value) {
                            return ((value / 100) * 100).toFixed(0) + "%"; // convert it to percentage
                        }
                    }
                }
            ]
        }
    };

    lineChartData = {
        datasets: this.state.chartDatasets
    };

    singleData = { capital: [], rwaTop: [], rwaBottom: [], total: 0 };
    consolData = { capital: [], rwaTop: [], rwaBottom: [], total: 0 };
    capitalScenarioNo = { single: 1, consol: 1 };

    componentDidMount() {
        this.getListFile();
    }

    formatNumber = (input) => {
        return Number((+input).toFixed(2)).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    isNotEmpty = (input) => {
        if (input || input === 0) {
            return true;
        }
        return false;
    };

    onChangeDate = (date) => {
        this.setState({ chartLabels: null }, () => {
            const selectedYear = moment(date, "DD/MM/YYYY").year();
            const chartLabels = [selectedYear, selectedYear + 1, selectedYear + 2, selectedYear + 3];
            this.lineChartData.labels = [...chartLabels];
            const chartDatasets = [...this.state.chartDatasets];
            chartDatasets[0].data = [0, 0, 0, 0];
            chartDatasets[1].data = [0, 0, 0, 0];
            this.setState({
                loading: true,
                calculated: false,
                disabledInput: {},
                selectedDate: date,
                carTbl: CAR_TABLE,
                sumCapitalAMT: null,
                sumCapitalSecenario: null,
                sumCapitalT1: null,
                sumCapitalT2: null,
                sumCapitalT3: null,
                sumRwaCHG: null,
                sumRwaT1: null,
                sumRwaT2: null,
                sumRwaT3: null,
                chartDatasets,
                chartLabels
            }, () => {
                this.getPlanningDetail();
            });
        })
    }

    onChangeBank = (bank) => {
        const chartDatasets = [...this.state.chartDatasets];
        chartDatasets[0].data = [0, 0, 0, 0];
        chartDatasets[1].data = [0, 0, 0, 0];
        this.setState({
            calculated: false,
            disabledInput: {},
            selectedBank: bank,
            carTbl: CAR_TABLE,
            capitalTbl: bank === "HDBANK" ? this.singleData.capital : this.consolData.capital,
            rwaTblTop: bank === "HDBANK" ? this.singleData.rwaTop : this.consolData.rwaTop,
            rwaTblBottom: bank === "HDBANK" ? this.singleData.rwaBottom : this.consolData.rwaBottom,
            sumCapitalAMT: null,
            sumCapitalSecenario: null,
            sumCapitalT1: null,
            sumCapitalT2: null,
            sumCapitalT3: null,
            sumRwaCHG: null,
            sumRwaT1: null,
            sumRwaT2: null,
            sumRwaT3: null,
            totalRwa: bank === "HDBANK" ? this.singleData.total : this.consolData.total,
            capitalScenario: bank === "HDBANK" ? this.capitalScenarioNo.single : this.capitalScenarioNo.consol,
            chartDatasets
        });
    };

    setCapitalScenario = () => {
        Http.getCapitalPlanningDetails(this.state.selectedDate).then((res) => {
            if (res && res.Success & res.Data.length) {
                this.capitalScenarioNo = {
                    single: +res.Data[0].capital_scenario_single + 1,
                    consol: +res.Data[0].capital_scenario_consol + 1
                };
                this.setState({
                    capitalScenario: this.state.selectedBank === "HDBANK" ? this.capitalScenarioNo.single : this.capitalScenarioNo.consol,
                })
            } else {
                this.capitalScenarioNo = {
                    single: 1,
                    consol: 1
                };
                this.setState({
                    capitalScenario: 1
                })
            }
        })
    }

    getPlanningDetail = () => {
        Http.getCapitalPlanningDetails(this.state.selectedDate).then((res) => {
            if (res && res.Success & res.Data.length) {
                const capSingleData = res.Data[0].single;
                const capConsoleData = res.Data[0].consol;
                this.capitalScenarioNo = {
                    single: +res.Data[0].capital_scenario_single + 1,
                    consol: +res.Data[0].capital_scenario_consol + 1
                };
                this.singleData = {
                    capital: [
                        ["CET1", capSingleData.cet1, null, null, null, null, null, null, null, null, null],
                        [
                            "CET1Deduct",
                            capSingleData.cet1_deduct,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ],
                        ["AT1", capSingleData.at1, null, null, null, null, null, null, null, null, null],
                        [
                            "AT1Deduct",
                            capSingleData.at1_deduct,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ],
                        ["Tier 2", capSingleData.tier_2, null, null, null, null, null, null, null, null, null],
                        [
                            "Tier 2 Deduct",
                            capSingleData.tier_2_deduct,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ],
                        ["Total", capSingleData.total, "Total", null, null, null, null, null, null, null, null]
                    ],
                    rwaTop:
                        [
                            ["Sovereign exposures", capSingleData.ead_sovereign_exposures, null, capSingleData.rwa_sovereign_exposures, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Financial Institution exposures", capSingleData.ead_financial_institution_exposures, null, capSingleData.rwa_financial_institution_exposures, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Corporate exposures", capSingleData.ead_corporate_exposures, null, capSingleData.rwa_corporate_exposures, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Retail exposures", capSingleData.ead_retail_exposures, null, capSingleData.rwa_retail_exposures, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Defaulted exposures", capSingleData.ead_defaulted_exposures, null, capSingleData.rwa_defaulted_exposures, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Other assets", capSingleData.ead_other_assets, null, capSingleData.rwa_other_assets, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Real estate exposures", capSingleData.ead_real_estate_exposures, null, capSingleData.rwa_real_estate_exposures, null, null, null, null, null, null, null, null, null, null, null, null, null, null]
                        ],
                    rwaBottom:
                        [
                            ["CCR", null, null, capSingleData.rwa_ccr, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["CVA", capSingleData.ead_cva, null, capSingleData.rwa_cva, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Operational Risk", null, null, capSingleData.rwa_operational_risk, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Market risk", null, null, capSingleData.rwa_market_risk, null, null, null, null, null, null, null, null, null, null, null, null, null, null]
                        ]
                };
                this.singleData.total = 0;
                for (const property in capSingleData) {
                    if (property.includes("rwa")) {
                        this.singleData.total = this.singleData.total + +capSingleData[property]
                    }
                }
                this.consolData = {
                    capital: [
                        ["CET1", capConsoleData.cet1, null, null, null, null, null, null, null, null, null],
                        [
                            "CET1Deduct",
                            capConsoleData.cet1_deduct,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ],
                        ["AT1", capConsoleData.at1, null, null, null, null, null, null, null, null, null],
                        [
                            "AT1Deduct",
                            capConsoleData.at1_deduct,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ],
                        ["Tier 2", capConsoleData.tier_2, null, null, null, null, null, null, null, null, null],
                        [
                            "Tier 2 Deduct",
                            capConsoleData.tier_2_deduct,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null,
                            null
                        ],
                        ["Total", capConsoleData.total, "Total", null, null, null, null, null, null, null, null]
                    ],
                    rwaTop:
                        [
                            ["Sovereign exposures", capConsoleData.ead_sovereign_exposures, null, capConsoleData.rwa_sovereign_exposures, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Financial Institution exposures", capConsoleData.ead_financial_institution_exposures, null, capConsoleData.rwa_financial_institution_exposures, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Corporate exposures", capConsoleData.ead_corporate_exposures, null, capConsoleData.rwa_corporate_exposures, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Retail exposures", capConsoleData.ead_retail_exposures, null, capConsoleData.rwa_retail_exposures, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Defaulted exposures", capConsoleData.ead_defaulted_exposures, null, capConsoleData.rwa_defaulted_exposures, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Other assets", capConsoleData.ead_other_assets, null, capConsoleData.rwa_other_assets, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Real estate exposures", capConsoleData.ead_real_estate_exposures, null, capConsoleData.rwa_real_estate_exposures, null, null, null, null, null, null, null, null, null, null, null, null, null, null]
                        ],
                    rwaBottom:
                        [
                            ["CCR", null, null, capConsoleData.rwa_ccr, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["CVA", capConsoleData.ead_cva, null, capConsoleData.rwa_cva, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Operational Risk", null, null, capConsoleData.rwa_operational_risk, null, null, null, null, null, null, null, null, null, null, null, null, null, null],
                            ["Market risk", null, null, capConsoleData.rwa_market_risk, null, null, null, null, null, null, null, null, null, null, null, null, null, null]
                        ]
                };
                this.consolData.total = 0;
                for (const property in capConsoleData) {
                    if (property.includes("rwa")) {
                        this.consolData.total = this.consolData.total + +capConsoleData[property]
                    }
                }
                this.setState({
                    capitalTbl: this.state.selectedBank === "HDBANK" ? this.singleData.capital : this.consolData.capital,
                    rwaTblTop: this.state.selectedBank === "HDBANK" ? this.singleData.rwaTop : this.consolData.rwaTop,
                    rwaTblBottom: this.state.selectedBank === "HDBANK" ? this.singleData.rwaBottom : this.consolData.rwaBottom,
                    totalRwa: this.state.selectedBank === "HDBANK" ? this.singleData.total : this.consolData.total,
                    capitalScenario: this.state.selectedBank === "HDBANK" ? this.capitalScenarioNo.single : this.capitalScenarioNo.consol,
                    loading: false
                })
            } else {
                this.capitalScenarioNo = {
                    single: 1,
                    consol: 1
                };
                this.setState({
                    capitalTbl: this.state.selectedBank === "HDBANK" ? CAP_S_CAPITAL_TABLE : CAP_C_CAPITAL_TABLE,
                    rwaTblTop: this.state.selectedBank === "HDBANK" ? CAP_S_RWA_TABLE_TOP : CAP_C_RWA_TABLE_TOP,
                    rwaTblBottom: this.state.selectedBank === "HDBANK" ? CAP_S_RWA_TABLE_BOTTOM : CAP_C_RWA_TABLE_BOTTOM,
                    totalRwa: 0,
                    capitalScenario: 1,
                    loading: false
                })
            }
        });
    }

    getListFile = () => {
        Http.getListBatch(Business.COMPONENT.CAR).then((data) => { //Get batch of CAR
            if (data && data.Success) {
                let listData = [];
                for (let index = 0; index < data.Data.length; index++) {
                    const element = data.Data[index];
                    if (!element) continue;
                    if (element.file_name.includes("ICAAP")) continue;
                    const formatedDate = moment(element.report_date).format("DD/MM/YYYY");
                    if (!listData.includes(formatedDate)) listData.push(formatedDate);
                }
                listData = listData.sort((a, b) => {
                    return new Date(a.report_date).getTime() - new Date(b.report_date).getTime();
                });
                const selectedYear = moment(listData[0], "DD/MM/YYYY").year();
                const chartLabels = [selectedYear, selectedYear + 1, selectedYear + 2, selectedYear + 3];
                this.lineChartData.labels = chartLabels;
                this.setState({
                    selectedDate: listData[0],
                    snapshotDates: listData,
                    chartLabels
                }, () => {
                    this.getPlanningDetail();
                });
            }
        });
    };

    onCapitalInputChange = (event, row, column) => {
        let capitalTbl = JSON.parse(JSON.stringify(this.state.capitalTbl));
        if (event) capitalTbl[row][column] = event.target.value;
        capitalTbl = capitalTbl.map((row, index) => {
            row[4] = row[1] * (1 + (+row[2] || 0) / 100);
            row[3] = row[1] * (1 + (+row[2] || 0) / 100) - row[1];
            row[8] = row[1] * (1 + (+row[2] || 0) / 100) * (1 + (+row[5] || 0) / 100);
            row[9] = row[1] * (1 + (+row[2] || 0) / 100) * (1 + (+row[5] || 0) / 100) * (1 + (+row[6] || 0) / 100);
            row[10] = row[1] * (1 + (+row[2] || 0) / 100) * (1 + (+row[5] || 0) / 100) * (1 + (+row[6] || 0) / 100) * (1 + (+row[7] || 0) / 100);
            return row;
        });

        // Calculate capital sum
        const sumCapitalAMT =
            capitalTbl[0][3] -
            capitalTbl[1][3] +
            +capitalTbl[2][3] -
            capitalTbl[3][3] +
            +capitalTbl[4][3] -
            capitalTbl[5][3];
        const sumCapitalSecenario =
            capitalTbl[0][4] -
            capitalTbl[1][4] +
            +capitalTbl[2][4] -
            capitalTbl[3][4] +
            +capitalTbl[4][4] -
            capitalTbl[5][4];
        const sumCapitalT1 =
            capitalTbl[0][8] -
            capitalTbl[1][8] +
            +capitalTbl[2][8] -
            capitalTbl[3][8] +
            +capitalTbl[4][8] -
            capitalTbl[5][8];
        const sumCapitalT2 =
            capitalTbl[0][9] -
            capitalTbl[1][9] +
            +capitalTbl[2][9] -
            capitalTbl[3][9] +
            +capitalTbl[4][9] -
            capitalTbl[5][9];
        const sumCapitalT3 =
            capitalTbl[0][10] -
            capitalTbl[1][10] +
            +capitalTbl[2][10] -
            capitalTbl[3][10] +
            +capitalTbl[4][10] -
            capitalTbl[5][10];

        // Calculate CAR table
        const carTbl = JSON.parse(JSON.stringify(this.state.carTbl));

        carTbl[0][0] = ((capitalTbl[0][1] - capitalTbl[1][1]) / this.state.totalRwa) * 100;
        carTbl[0][1] = ((capitalTbl[0][4] - capitalTbl[1][4]) / this.state.sumRwaCHG) * 100;
        carTbl[0][2] = ((capitalTbl[0][8] - capitalTbl[1][8]) / this.state.sumRwaT1) * 100;
        carTbl[0][3] = ((capitalTbl[0][9] - capitalTbl[1][9]) / this.state.sumRwaT2) * 100;
        carTbl[0][4] = ((capitalTbl[0][10] - capitalTbl[1][10]) / this.state.sumRwaT3) * 100;

        carTbl[1][0] =
            ((capitalTbl[0][1] - capitalTbl[1][1] + capitalTbl[2][1] - capitalTbl[3][1]) / this.state.totalRwa) * 100;
        carTbl[1][1] =
            ((capitalTbl[0][4] - capitalTbl[1][4] + capitalTbl[2][4] - capitalTbl[3][4]) / this.state.sumRwaCHG) * 100;
        carTbl[1][2] =
            ((capitalTbl[0][8] - capitalTbl[1][8] + capitalTbl[2][8] - capitalTbl[3][8]) / this.state.sumRwaT1) * 100;
        carTbl[1][3] =
            ((capitalTbl[0][9] - capitalTbl[1][9] + capitalTbl[2][9] - capitalTbl[3][9]) / this.state.sumRwaT2) * 100;
        carTbl[1][4] =
            ((capitalTbl[0][10] - capitalTbl[1][10] + capitalTbl[2][10] - capitalTbl[3][10]) / this.state.sumRwaT3) *
            100;

        carTbl[2][0] = (capitalTbl[6][1] / this.state.totalRwa) * 100;
        carTbl[2][1] = (sumCapitalSecenario / this.state.sumRwaCHG) * 100;
        carTbl[2][2] = (sumCapitalT1 / this.state.sumRwaT1) * 100;
        carTbl[2][3] = (sumCapitalT2 / this.state.sumRwaT2) * 100;
        carTbl[2][4] = (sumCapitalT3 / this.state.sumRwaT3) * 100;

        // Update chart
        let chartDatasets = [...this.state.chartDatasets];
        chartDatasets[0].data = [
            this.formatNumber(carTbl[2][0]) || 0,
            this.formatNumber(carTbl[2][0]) || 0,
            this.formatNumber(carTbl[2][0]) || 0,
            this.formatNumber(carTbl[2][0]) || 0
        ];
        chartDatasets[1].data = [
            this.formatNumber(carTbl[2][1]) || 0,
            this.formatNumber(carTbl[2][2]) || 0,
            this.formatNumber(carTbl[2][3]) || 0,
            this.formatNumber(carTbl[2][4]) || 0
        ];

        this.setState({
            capitalTbl,
            sumCapitalAMT,
            sumCapitalSecenario,
            sumCapitalT1,
            sumCapitalT2,
            sumCapitalT3,
            carTbl,
            chartDatasets
        });
    };

    onRwaTopInputChange = (event, row, column) => {
        let capitalTbl = JSON.parse(JSON.stringify(this.state.capitalTbl));
        let rwaTblTop = JSON.parse(JSON.stringify(this.state.rwaTblTop));
        let rwaTblBottom = JSON.parse(JSON.stringify(this.state.rwaTblBottom));
        if (event) rwaTblTop[row][column] = event.target.value;

        // Disable column
        const disabledInput = { ...this.state.disabledInput };
        if (column === 4) {
            if (this.isNotEmpty(event.target.value)) {
                rwaTblTop[row][8] = null;
                disabledInput[`${row}_8`] = true;
            } else if (!this.isNotEmpty(event.target.value) && this.isNotEmpty(row[6])) {
                rwaTblTop[row][8] = null;
                disabledInput[`${row}_8`] = true;
            } else {
                rwaTblTop[row][8] = null;
                disabledInput[`${row}_8`] = false;
            }
        }
        if (column === 6) {
            if (this.isNotEmpty(event.target.value)) {
                rwaTblTop[row][8] = null;
                disabledInput[`${row}_8`] = true;
            } else if (!this.isNotEmpty(event.target.value) && this.isNotEmpty(row[4])) {
                rwaTblTop[row][8] = null;
                disabledInput[`${row}_8`] = true;
            } else {
                rwaTblTop[row][8] = null;
                disabledInput[`${row}_8`] = false;
            }
        }
        if (column === 8) {
            if (this.isNotEmpty(event.target.value)) {
                rwaTblTop[row][4] = null;
                rwaTblTop[row][6] = null;
                disabledInput[`${row}_4`] = true;
                disabledInput[`${row}_6`] = true;
            } else {
                rwaTblTop[row][4] = null;
                rwaTblTop[row][6] = null;
                disabledInput[`${row}_4`] = false;
                disabledInput[`${row}_6`] = false;
            }
        }

        rwaTblTop = rwaTblTop.map((row, index) => {
            row[2] = row[3] / row[1];
            row[5] = row[1] * (1 + (+row[4] || 0) / 100) - row[1];
            row[7] = row[3] / row[1] + (+row[6] || 0) / 100 - row[3] / row[1];
            row[9] = row[1] * (1 + (+row[4] || 0) / 100);
            row[10] = row[3] / row[1] + (+row[6] || 0) / 100;
            row[11] =
                !this.isNotEmpty(row[4]) && !this.isNotEmpty(row[6])
                    ? row[3] * (1 + (+row[8] || 0) / 100)
                    : row[1] * (1 + (+row[4] || 0) / 100) * (row[3] / row[1] + (+row[6] || 0) / 100);
            row[15] =
                (!this.isNotEmpty(row[4]) && !this.isNotEmpty(row[6])
                    ? row[3] * (1 + (+row[8] || 0) / 100)
                    : row[1] * (1 + (+row[4] || 0) / 100) * (row[3] / row[1] + (+row[6] || 0) / 100)) *
                (1 + (+row[12] || 0) / 100);
            row[16] =
                (!this.isNotEmpty(row[4]) && !this.isNotEmpty(row[6])
                    ? row[3] * (1 + (+row[8] || 0) / 100)
                    : row[1] * (1 + (+row[4] || 0) / 100) * (row[3] / row[1] + (+row[6] || 0) / 100)) *
                (1 + (+row[12] || 0) / 100) *
                (1 + (+row[13] || 0) / 100);
            row[17] =
                (!this.isNotEmpty(row[4]) && !this.isNotEmpty(row[6])
                    ? row[3] * (1 + (+row[8] || 0) / 100)
                    : row[1] * (1 + (+row[4] || 0) / 100) * (row[3] / row[1] + (+row[6] || 0) / 100)) *
                (1 + (+row[12] || 0) / 100) *
                (1 + (+row[13] || 0) / 100) *
                (1 + (+row[14] || 0) / 100);
            return row;
        });

        // Calculate rwa sum
        let sumRwaCHG = 0,
            sumRwaT1 = 0,
            sumRwaT2 = 0,
            sumRwaT3 = 0;
        rwaTblTop.forEach((row) => {
            sumRwaCHG += +row[11];
            sumRwaT1 += +row[15];
            sumRwaT2 += +row[16];
            sumRwaT3 += +row[17];
        });
        rwaTblBottom.forEach((row) => {
            sumRwaCHG += +row[11];
            sumRwaT1 += +row[15];
            sumRwaT2 += +row[16];
            sumRwaT3 += +row[17];
        });

        // Calculate CAR table
        const carTbl = JSON.parse(JSON.stringify(this.state.carTbl));

        carTbl[0][0] = ((capitalTbl[0][1] - capitalTbl[1][1]) / this.state.totalRwa) * 100;
        carTbl[0][1] = ((capitalTbl[0][4] - capitalTbl[1][4]) / sumRwaCHG) * 100;
        carTbl[0][2] = ((capitalTbl[0][8] - capitalTbl[1][8]) / sumRwaT1) * 100;
        carTbl[0][3] = ((capitalTbl[0][9] - capitalTbl[1][9]) / sumRwaT2) * 100;
        carTbl[0][4] = ((capitalTbl[0][10] - capitalTbl[1][10]) / sumRwaT3) * 100;

        carTbl[1][0] =
            ((capitalTbl[0][1] - capitalTbl[1][1] + capitalTbl[2][1] - capitalTbl[3][1]) / this.state.totalRwa) * 100;
        carTbl[1][1] = ((capitalTbl[0][4] - capitalTbl[1][4] + capitalTbl[2][4] - capitalTbl[3][4]) / sumRwaCHG) * 100;
        carTbl[1][2] = ((capitalTbl[0][8] - capitalTbl[1][8] + capitalTbl[2][8] - capitalTbl[3][8]) / sumRwaT1) * 100;
        carTbl[1][3] = ((capitalTbl[0][9] - capitalTbl[1][9] + capitalTbl[2][9] - capitalTbl[3][9]) / sumRwaT2) * 100;
        carTbl[1][4] =
            ((capitalTbl[0][10] - capitalTbl[1][10] + capitalTbl[2][10] - capitalTbl[3][10]) / sumRwaT3) * 100;

        carTbl[2][0] = (capitalTbl[6][1] / this.state.totalRwa) * 100;
        carTbl[2][1] = (this.state.sumCapitalSecenario / sumRwaCHG) * 100;
        carTbl[2][2] = (this.state.sumCapitalT1 / sumRwaT1) * 100;
        carTbl[2][3] = (this.state.sumCapitalT2 / sumRwaT2) * 100;
        carTbl[2][4] = (this.state.sumCapitalT3 / sumRwaT3) * 100;

        // Update chart
        let chartDatasets = [...this.state.chartDatasets];
        chartDatasets[0].data = [
            this.formatNumber(carTbl[2][0]) || 0,
            this.formatNumber(carTbl[2][0]) || 0,
            this.formatNumber(carTbl[2][0]) || 0,
            this.formatNumber(carTbl[2][0]) || 0
        ];
        chartDatasets[1].data = [
            this.formatNumber(carTbl[2][1]) || 0,
            this.formatNumber(carTbl[2][2]) || 0,
            this.formatNumber(carTbl[2][3]) || 0,
            this.formatNumber(carTbl[2][4]) || 0
        ];

        this.setState({ rwaTblTop, disabledInput, sumRwaCHG, sumRwaT1, sumRwaT2, sumRwaT3, carTbl, chartDatasets });
    };

    onRwaBottomInputChange = (event, row, column) => {
        let capitalTbl = JSON.parse(JSON.stringify(this.state.capitalTbl));
        let rwaTblTop = JSON.parse(JSON.stringify(this.state.rwaTblTop));
        let rwaTblBottom = JSON.parse(JSON.stringify(this.state.rwaTblBottom));
        if (event) rwaTblBottom[row][column] = event.target.value;
        rwaTblBottom = rwaTblBottom.map((row, index) => {
            row[11] = row[3] * (1 + (+row[8] || 0) / 100);
            row[15] = row[3] * (1 + (+row[8] || 0) / 100) * (1 + (+row[12] || 0) / 100);
            row[16] = row[3] * (1 + (+row[8] || 0) / 100) * (1 + (+row[12] || 0) / 100) * (1 + (+row[13] || 0) / 100);
            row[17] = row[3] * (1 + (+row[8] || 0) / 100) * (1 + (+row[12] || 0) / 100) * (1 + (+row[13] || 0) / 100) * (1 + (+row[14] || 0) / 100);

            return row;
        });

        // Calculate rwa sum
        let sumRwaCHG = 0,
            sumRwaT1 = 0,
            sumRwaT2 = 0,
            sumRwaT3 = 0;
        rwaTblTop.forEach((row) => {
            sumRwaCHG += +row[11];
            sumRwaT1 += +row[15];
            sumRwaT2 += +row[16];
            sumRwaT3 += +row[17];
        });
        rwaTblBottom.forEach((row) => {
            sumRwaCHG += +row[11];
            sumRwaT1 += +row[15];
            sumRwaT2 += +row[16];
            sumRwaT3 += +row[17];
        });

        // Calculate CAR table
        const carTbl = JSON.parse(JSON.stringify(this.state.carTbl));

        carTbl[0][0] = ((capitalTbl[0][1] - capitalTbl[1][1]) / this.state.totalRwa) * 100;
        carTbl[0][1] = ((capitalTbl[0][4] - capitalTbl[1][4]) / sumRwaCHG) * 100;
        carTbl[0][2] = ((capitalTbl[0][8] - capitalTbl[1][8]) / sumRwaT1) * 100;
        carTbl[0][3] = ((capitalTbl[0][9] - capitalTbl[1][9]) / sumRwaT2) * 100;
        carTbl[0][4] = ((capitalTbl[0][10] - capitalTbl[1][10]) / sumRwaT3) * 100;

        carTbl[1][0] =
            ((capitalTbl[0][1] - capitalTbl[1][1] + capitalTbl[2][1] - capitalTbl[3][1]) / this.state.totalRwa) * 100;
        carTbl[1][1] = ((capitalTbl[0][4] - capitalTbl[1][4] + capitalTbl[2][4] - capitalTbl[3][4]) / sumRwaCHG) * 100;
        carTbl[1][2] = ((capitalTbl[0][8] - capitalTbl[1][8] + capitalTbl[2][8] - capitalTbl[3][8]) / sumRwaT1) * 100;
        carTbl[1][3] = ((capitalTbl[0][9] - capitalTbl[1][9] + capitalTbl[2][9] - capitalTbl[3][9]) / sumRwaT2) * 100;
        carTbl[1][4] =
            ((capitalTbl[0][10] - capitalTbl[1][10] + capitalTbl[2][10] - capitalTbl[3][10]) / sumRwaT3) * 100;

        carTbl[2][0] = (capitalTbl[6][1] / this.state.totalRwa) * 100;
        carTbl[2][1] = (this.state.sumCapitalSecenario / sumRwaCHG) * 100;
        carTbl[2][2] = (this.state.sumCapitalT1 / sumRwaT1) * 100;
        carTbl[2][3] = (this.state.sumCapitalT2 / sumRwaT2) * 100;
        carTbl[2][4] = (this.state.sumCapitalT3 / sumRwaT3) * 100;

        // Update chart
        let chartDatasets = [...this.state.chartDatasets];
        chartDatasets[0].data = [
            this.formatNumber(carTbl[2][0]) || 0,
            this.formatNumber(carTbl[2][0]) || 0,
            this.formatNumber(carTbl[2][0]) || 0,
            this.formatNumber(carTbl[2][0]) || 0
        ];
        chartDatasets[1].data = [
            this.formatNumber(carTbl[2][1]) || 0,
            this.formatNumber(carTbl[2][2]) || 0,
            this.formatNumber(carTbl[2][3]) || 0,
            this.formatNumber(carTbl[2][4]) || 0
        ];

        this.setState({ rwaTblBottom, sumRwaCHG, sumRwaT1, sumRwaT2, sumRwaT3, carTbl, chartDatasets });
    };

    onCalculating = () => {
        if (!this.state.reportName) {
            Business.showAlert({
                title: 'Error',
                content: 'You must enter value for Report Name.'
            })
            return;
        }
        this.setState({ loading: true });
        this.onCapitalInputChange();
        this.onRwaTopInputChange();
        setTimeout(() => {
            this.onRwaBottomInputChange();
            this.setState({ calculated: true, loading: false });
        }, 550);
    }

    onPrepareExport = () => {
        if (!this.state.reportName) {
            Business.showAlert({
                title: 'Error',
                content: 'You must enter value for Report Name.'
            })
            return false;
        } else if (!this.isNotEmpty(this.state.capitalScenario)) {
            Business.showAlert({
                title: 'Error',
                content: 'You must enter value for Capital Scenario.'
            })
            return false;
        } else {
            this.setState({ showConfirmation: true });
        }
    }

    export = async () => {
        let axiosResponse = await Http.downloadCapTemplate();
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(axiosResponse.data);
        const worksheet = workbook.getWorksheet("Sheet 1");

        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber === 6) {
                row.getCell("C").value = this.state.selectedDate;
                row.getCell("E").value = this.state.selectedBank;
                row.getCell("G").value = this.state.reportName;
                row.getCell("I").value = this.state.capitalScenario;
            }
            if (rowNumber === 8) {
                row.getCell("J").value = moment(this.state.selectedDate, "DD/MM/YYYY").year() + 1;
                row.getCell("L").value = moment(this.state.selectedDate, "DD/MM/YYYY").year() + 2;
                row.getCell("N").value = moment(this.state.selectedDate, "DD/MM/YYYY").year() + 3;
            }
            if (rowNumber >= 9 && rowNumber <= 11) {
                row.getCell("G").value = this.state.carTbl[rowNumber - 9][0] / 100;
                row.getCell("H").value = this.state.carTbl[rowNumber - 9][1] / 100;
                row.getCell("J").value = this.state.carTbl[rowNumber - 9][2] / 100;
                row.getCell("L").value = this.state.carTbl[rowNumber - 9][3] / 100;
                row.getCell("N").value = this.state.carTbl[rowNumber - 9][4] / 100;
            }
            if (rowNumber === 14) {
                row.getCell("M").value = `${moment(this.state.selectedDate, "DD/MM/YYYY").year() + 1}%`;
                row.getCell("O").value = `${moment(this.state.selectedDate, "DD/MM/YYYY").year() + 2}%`;
                row.getCell("Q").value = `${moment(this.state.selectedDate, "DD/MM/YYYY").year() + 3}%`;
                row.getCell("S").value = `Capital ${moment(this.state.selectedDate, "DD/MM/YYYY").year() + 1}`;
                row.getCell("U").value = `Capital ${moment(this.state.selectedDate, "DD/MM/YYYY").year() + 2}`;
                row.getCell("W").value = `Capital ${moment(this.state.selectedDate, "DD/MM/YYYY").year() + 3}`;
            }
            if (rowNumber >= 15 && rowNumber <= 20) {
                row.getCell("E").value = this.state.capitalTbl[rowNumber - 15][1];
                row.getCell("G").value = this.state.capitalTbl[rowNumber - 15][2];
                row.getCell("I").value = this.state.capitalTbl[rowNumber - 15][3];
                row.getCell("K").value = this.state.capitalTbl[rowNumber - 15][4];
                row.getCell("L").value = this.state.capitalTbl[rowNumber - 15][5];
                row.getCell("N").value = this.state.capitalTbl[rowNumber - 15][6];
                row.getCell("P").value = this.state.capitalTbl[rowNumber - 15][7];
                row.getCell("S").value = this.state.capitalTbl[rowNumber - 15][8];
                row.getCell("U").value = this.state.capitalTbl[rowNumber - 15][9];
                row.getCell("W").value = this.state.capitalTbl[rowNumber - 15][10];
            }
            if (rowNumber === 21) {
                row.getCell("E").value = this.state.capitalTbl[6][1];
                row.getCell("I").value = this.state.sumCapitalAMT;
                row.getCell("K").value = this.state.sumCapitalSecenario;
                row.getCell("S").value = this.state.sumCapitalT1;
                row.getCell("U").value = this.state.sumCapitalT2;
                row.getCell("W").value = this.state.sumCapitalT3;
            }
            if (rowNumber === 24) {
                row.getCell("Z").value = `${moment(this.state.selectedDate, "DD/MM/YYYY").year() + 1}%`;
                row.getCell("AA").value = `${moment(this.state.selectedDate, "DD/MM/YYYY").year() + 2}%`;
                row.getCell("AB").value = `${moment(this.state.selectedDate, "DD/MM/YYYY").year() + 3}%`;
                row.getCell("AC").value = `RWA ${moment(this.state.selectedDate, "DD/MM/YYYY").year() + 1}`;
                row.getCell("AD").value = `RWA ${moment(this.state.selectedDate, "DD/MM/YYYY").year() + 2}`;
                row.getCell("AE").value = `RWA ${moment(this.state.selectedDate, "DD/MM/YYYY").year() + 3}`;
            }
            if (rowNumber >= 25 && rowNumber <= 31) {
                row.getCell("E").value = this.state.rwaTblTop[rowNumber - 25][1];
                row.getCell("G").value = this.state.rwaTblTop[rowNumber - 25][2];
                row.getCell("I").value = this.state.rwaTblTop[rowNumber - 25][3];
                row.getCell("K").value = this.state.rwaTblTop[rowNumber - 25][4];
                row.getCell("M").value = this.state.rwaTblTop[rowNumber - 25][5];
                row.getCell("O").value = this.state.rwaTblTop[rowNumber - 25][6];
                row.getCell("Q").value = this.state.rwaTblTop[rowNumber - 25][7];
                row.getCell("S").value = this.state.rwaTblTop[rowNumber - 25][8];
                row.getCell("U").value = this.state.rwaTblTop[rowNumber - 25][9];
                row.getCell("W").value = this.state.rwaTblTop[rowNumber - 25][10];
                row.getCell("Y").value = this.state.rwaTblTop[rowNumber - 25][11];
                row.getCell("Z").value = this.state.rwaTblTop[rowNumber - 25][12];
                row.getCell("AA").value = this.state.rwaTblTop[rowNumber - 25][13];
                row.getCell("AB").value = this.state.rwaTblTop[rowNumber - 25][14];
                row.getCell("AC").value = this.state.rwaTblTop[rowNumber - 25][15];
                row.getCell("AD").value = this.state.rwaTblTop[rowNumber - 25][16];
                row.getCell("AE").value = this.state.rwaTblTop[rowNumber - 25][17];
            }
            if (rowNumber >= 32 && rowNumber <= 35) {
                row.getCell("E").value = this.state.rwaTblBottom[rowNumber - 32][1];
                row.getCell("G").value = this.state.rwaTblBottom[rowNumber - 32][2];
                row.getCell("I").value = this.state.rwaTblBottom[rowNumber - 32][3];
                row.getCell("K").value = this.state.rwaTblBottom[rowNumber - 32][4];
                row.getCell("M").value = this.state.rwaTblBottom[rowNumber - 32][5];
                row.getCell("O").value = this.state.rwaTblBottom[rowNumber - 32][6];
                row.getCell("Q").value = this.state.rwaTblBottom[rowNumber - 32][7];
                row.getCell("S").value = this.state.rwaTblBottom[rowNumber - 32][8];
                row.getCell("U").value = this.state.rwaTblBottom[rowNumber - 32][9];
                row.getCell("W").value = this.state.rwaTblBottom[rowNumber - 32][10];
                row.getCell("Y").value = this.state.rwaTblBottom[rowNumber - 32][11];
                row.getCell("Z").value = this.state.rwaTblBottom[rowNumber - 32][12];
                row.getCell("AA").value = this.state.rwaTblBottom[rowNumber - 32][13];
                row.getCell("AB").value = this.state.rwaTblBottom[rowNumber - 32][14];
                row.getCell("AC").value = this.state.rwaTblBottom[rowNumber - 32][15];
                row.getCell("AD").value = this.state.rwaTblBottom[rowNumber - 32][16];
                row.getCell("AE").value = this.state.rwaTblBottom[rowNumber - 32][17];
            }
            if (rowNumber === 36) {
                row.getCell("I").value = this.state.totalRwa;
                row.getCell("Y").value = this.state.sumRwaCHG;
                row.getCell("AC").value = this.state.sumRwaT1;
                row.getCell("AD").value = this.state.sumRwaT2;
                row.getCell("AE").value = this.state.sumRwaT3;
            }
        })

        await new Promise(res => setTimeout(res, 700));
        const canvas = await html2canvas(document.getElementById("chart-container"));
        const image = workbook.addImage({
            base64: canvas.toDataURL(),
            extension: 'png',
        });
        worksheet.addImage(image, 'Q4:T11');

        // Handle saving report
        workbook.xlsx.writeBuffer().then((buffer) => {
            const file = new Blob([buffer]);
            const fileName = `${this.state.reportName}.xlsx`;
            const dicFileToBeUpload = {};
            const totalCount = file.size % chunkSize === 0 ? file.size / chunkSize : Math.floor(file.size / chunkSize) + 1; // Total count of chunks will have been upload to finish the file
            const fileID = uuidv4() + ".xlsx";
            dicFileToBeUpload[fileName] = {
                counter: 1,
                fileName,
                fileToBeUpload: file,
                beginingOfTheChunk: 0,
                endOfTheChunk: chunkSize,
                fileGuid: fileID,
                fileSize: file.size,
                chunkCount: totalCount > 0 ? totalCount : 1,
                isUploaded: false
            };
            this.setState({ dicFileToBeUpload }, () => {
                this.setState({ loading: true });
                this.onUploadChunkFile(fileName);
            });
        });
    };

    getCurrentFileUploadingInfo = (fileName) => {
        const { dicFileToBeUpload } = this.state;
        return dicFileToBeUpload[fileName];
    }

    updateDicFileToBeUpload = (fileName, data, cb) => {
        const dicFileToBeUpload = this.state.dicFileToBeUpload;
        if (dicFileToBeUpload.hasOwnProperty(fileName)) {
            dicFileToBeUpload[fileName] = { ...dicFileToBeUpload[fileName], data };
        }
        this.setState({ dicFileToBeUpload }, () => { cb && cb(); });
    }

    onUploadChunkFile = (fileName) => {
        try {
            let fileUploadingInfo = this.getCurrentFileUploadingInfo(fileName);
            const currentCounter = fileUploadingInfo.counter;
            fileUploadingInfo['counter'] = currentCounter + 1;

            this.updateDicFileToBeUpload(fileName, fileUploadingInfo, async () => {
                fileUploadingInfo = this.getCurrentFileUploadingInfo(fileName);
                const { fileGuid, chunkCount, fileToBeUpload, beginingOfTheChunk, endOfTheChunk } = fileUploadingInfo;

                if (currentCounter <= chunkCount) {
                    const chunk = fileToBeUpload.slice(beginingOfTheChunk, endOfTheChunk);

                    Http.uploadChuckFile(chunk, {
                        id: currentCounter,
                        fileName: fileGuid,
                    }).then(async response => {
                        const isSuccess = response ? response.Success : false;
                        if (isSuccess) {
                            fileUploadingInfo['beginingOfTheChunk'] = endOfTheChunk;
                            fileUploadingInfo['endOfTheChunk'] = endOfTheChunk + chunkSize;
                            this.updateDicFileToBeUpload(fileName, fileUploadingInfo, async () => {
                                fileUploadingInfo = this.getCurrentFileUploadingInfo(fileName);
                                if (currentCounter == chunkCount) {
                                    fileUploadingInfo['isUploaded'] = true;
                                    this.updateDicFileToBeUpload(fileName, fileUploadingInfo, async () => {
                                        let isAllFilesUploaded = true;
                                        for (let fileName in this.state.dicFileToBeUpload) {
                                            if (this.state.dicFileToBeUpload[fileName]['isUploaded'] === false) {
                                                isAllFilesUploaded = false;
                                                break;
                                            }
                                        }
                                        await this.onUploadChunkFileComplete(isAllFilesUploaded, fileName);
                                    })
                                } else {
                                    this.onUploadChunkFile();
                                }
                            })
                        } else {
                            this.setState({ loading: false });
                            console.error('Error Occurred:', response.ErrorCode);
                            await this.handleUploadFileResponse(response);
                        }
                    })
                }
            })
        } catch (error) {
            this.setState({ loading: false });
            console.error(error);
        }
    }

    onUploadChunkFileComplete = async (isAllFilesUploaded, fileName) => {
        let fileUploadingInfo = this.getCurrentFileUploadingInfo(fileName);
        const { fileToBeUpload, fileGuid } = fileUploadingInfo;

        try {
            Http.uploadCapitalChunkFileComplete(
                fileGuid,
                {
                    originFileName: fileToBeUpload ? fileName : fileGuid,
                    fileGuid: fileGuid,
                    reportName: fileName.split(".")[0],
                    reportDate: this.state.selectedDate,
                    company: this.state.selectedBank,
                    // capitalScenario: this.state.capitalScenario,
                    isAllFilesUploaded,
                    fileExtension: FileExtension.XLSX,

                    isUploadOnly: true,
                    isUploadAndMerge: false,
                    isCalculateOnly: false,
                }
            ).then(res => {
                this.setState({ loading: false });
                this.handleUploadFileResponse(res);
            });
        } catch (error) {
            this.setState({ loading: false });
            console.error(error);
        }
    }

    handleUploadFileResponse = (res) => {
        if (res) {
            switch (res.ErrorCode) {
                case ErrorCode.PermissionDenie:
                    Business.showAlert({
                        title: 'Error',
                        content: 'You are not permission'
                    })
                    break;
                case ErrorCode.Empty:
                    Business.showAlert({
                        title: 'Error',
                        content: 'File is empty'
                    })
                    break;
                case ErrorCode.Exist:
                    Business.showAlert({
                        title: 'Error',
                        content: 'Name already exists in the system'
                    })
                    break;
                case ErrorCode.DataInvalid:
                    Business.showAlert({
                        title: 'Error',
                        content: res.Data
                    })
                    break;
                case ErrorCode.UnknowError:
                    Business.showAlert({
                        title: 'Error',
                        content: res.Data || 'System Error'
                    })
                    break;
                default:
                    Business.showAlert({
                        title: 'Info',
                        content: 'Successfully'
                    });
                    this.setCapitalScenario();
                    break;
            }
        } else {
            Business.showAlert({
                title: 'Error',
                content: 'Unknow Error'
            })
        }
    }


    render() {
        if (this.state.loading)
            return (
                <div style={{
                    height: Business.getHeightContent()
                }}>
                    <Loading size="small" />
                </div >
            );

        return Business.isHasRole([Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_CALCULATE]) && (
            <div className="card">
                <div className="header">
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "baseline",
                            justifyContent: "space-between"
                        }}
                    >
                        <h4 className="title">Capital Planning Details</h4>
                        <ButtonToolbar>
                            <Button
                                disabled={this.state.calculated === true || !Business.isHasRole([Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_CALCULATE])}
                                bsSize="small"
                                style={{
                                    borderRadius: "5px",
                                    fontWeight: 600,
                                    marginRight: "5px",
                                    marginLeft: "auto"
                                }}
                                active
                                onClick={() => this.onCalculating()}
                            >
                                Calculate
                            </Button>
                            <Button
                                disabled={!this.state.calculated || !Business.isHasRole([Business.ROLE_DEFINE_MAP.CAPITAL_PLANNING_SAVE])}
                                bsSize="small"
                                style={{
                                    borderRadius: "5px",
                                    fontWeight: 600,
                                    marginLeft: "auto"
                                }}
                                active
                                onClick={() => this.onPrepareExport()}
                            >
                                Save
                            </Button>
                        </ButtonToolbar>
                    </div>
                </div>
                <div className="content table-responsive table-full-width">
                    <div style={{ display: "flex", gap: "8px", width: "40%" }}>
                        <div style={{ display: "flex", alignItems: "center", flexDirection: "column", flex: 1 }}>
                            <p style={{ fontWeight: 700 }}>Snapshot Date</p>
                            <ButtonGroup justified>
                                <DropdownButton title={this.state.selectedDate} bsSize="small" block="true">
                                    {this.state.snapshotDates.map((date) => [
                                        <MenuItem
                                            onSelect={(eventKey, _) => this.onChangeDate(eventKey)}
                                            eventKey={date}
                                        >
                                            {date}
                                        </MenuItem>,
                                        <MenuItem divider />
                                    ])}
                                </DropdownButton>
                            </ButtonGroup>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", flexDirection: "column", flex: 1 }}>
                            <p style={{ fontWeight: 700 }}>Company</p>
                            <ButtonGroup justified>
                                <DropdownButton title={this.state.selectedBank} bsSize="small" block="true">
                                    <MenuItem onSelect={() => this.onChangeBank("HDBANK")}>{"HDBANK"}</MenuItem>
                                    <MenuItem divider />
                                    <MenuItem onSelect={() => this.onChangeBank("HDCONSOL")}>{"HDCONSOL"}</MenuItem>
                                    <MenuItem divider />
                                </DropdownButton>
                            </ButtonGroup>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", flexDirection: "column", flex: 1 }}>
                            <p style={{ fontWeight: 700 }}>Report Name</p>
                            <input
                                type="text"
                                style={{ height: "30px" }}
                                className="form-control"
                                value={this.state.reportName}
                                onChange={(event) => {
                                    this.setState({ reportName: event.target.value });
                                }}
                            />
                        </div>
                        <div style={{ display: "flex", alignItems: "center", flexDirection: "column", flex: 1 }}>
                            <p style={{ fontWeight: 700 }}>Capital Scenario</p>
                            <input type="number" style={{ height: "30px" }} className="form-control"
                                value={this.state.capitalScenario}
                                readOnly={true}
                            // onChange={(event) => {
                            //     this.setState({ capitalScenario: event.target.value });
                            // }}
                            />
                        </div>
                    </div>
                    <div style={{ height: 20 }} />
                    <div style={{ display: "flex", gap: "50px", alignItems: "center" }}>
                        <table
                            className="table table-hover table-striped"
                            style={{ width: "50%", height: "fit-content" }}
                        >
                            <tbody>
                                <tr>
                                    <td
                                        style={{
                                            width: "15%",
                                            verticalAlign: "middle",
                                            textAlign: "center",
                                            fontWeight: 700
                                        }}
                                        rowSpan={4}
                                    >
                                        CAR
                                    </td>
                                    <td>&nbsp;</td>
                                    <td style={{ fontWeight: 700 }}>Baseline</td>
                                    <td style={{ fontWeight: 700 }}>Scenario</td>
                                    <td style={{ fontWeight: 700 }}>
                                        {moment(this.state.selectedDate, "DD/MM/YYYY").year() + 1}
                                    </td>
                                    <td style={{ fontWeight: 700 }}>
                                        {moment(this.state.selectedDate, "DD/MM/YYYY").year() + 2}
                                    </td>
                                    <td style={{ fontWeight: 700 }}>
                                        {moment(this.state.selectedDate, "DD/MM/YYYY").year() + 3}
                                    </td>
                                </tr>
                                <tr>
                                    <td>CET1</td>
                                    {this.state.carTbl[0].map((col) => (
                                        <td>
                                            {this.state.calculated &&
                                                this.isNotEmpty(col) &&
                                                `${this.formatNumber(col)}%`}
                                        </td>
                                    ))}
                                </tr>
                                <tr>
                                    <td>Tier 1</td>
                                    {this.state.carTbl[1].map((col) => (
                                        <td>
                                            {this.state.calculated &&
                                                this.isNotEmpty(col) &&
                                                `${this.formatNumber(col)}%`}
                                        </td>
                                    ))}
                                </tr>
                                <tr>
                                    <td>CAR</td>
                                    {this.state.carTbl[2].map((col) => (
                                        <td>
                                            {this.state.calculated &&
                                                this.isNotEmpty(col) &&
                                                `${this.formatNumber(col)}%`}
                                        </td>
                                    ))}
                                </tr>
                            </tbody>
                        </table>
                        <div id="chart-container" style={{ width: "35%" }}>
                            {this.state.chartLabels && <Line ref={ref => this.chartRef = ref} redraw={true} options={this.lineChartOptions} data={this.lineChartData} />}
                        </div>
                    </div>
                    <div style={{ height: 20 }} />
                    <div style={{ display: "flex", gap: "10px" }}>
                        <table className="table table-hover table-striped capital-table" style={{ flex: 1 }}>
                            <thead>
                                <tr>
                                    <td style={{ textAlign: "center", fontWeight: 700 }}>Capital</td>
                                    <td style={{ textAlign: "center", fontWeight: 700 }}>Baseline</td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.capitalTbl.map((row) => (
                                    <tr>
                                        <td>{row[0]}</td>
                                        <td>{this.state.calculated && this.formatNumber(row[1])}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <table className="table table-hover table-striped capital-table" style={{ flex: 1 }}>
                            <thead>
                                <tr>
                                    <td style={{ textAlign: "center", fontWeight: 700 }}>% Change</td>
                                    <td style={{ textAlign: "center", fontWeight: 700 }}>AMT</td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.capitalTbl.map(
                                    (row, index) =>
                                        index !== this.state.capitalTbl.length - 1 && (
                                            <tr>
                                                <td>
                                                    {this.state.calculated && (
                                                        <input
                                                            type="number"
                                                            style={{ height: "30px" }}
                                                            className="form-control"
                                                            value={row[2]}
                                                            onChange={(event) =>
                                                                this.onCapitalInputChange(event, index, 2)
                                                            }
                                                        />
                                                    )}
                                                </td>
                                                <td>
                                                    {this.state.calculated &&
                                                        this.isNotEmpty(row[3]) &&
                                                        this.formatNumber(row[3])}
                                                </td>
                                            </tr>
                                        )
                                )}
                                <tr>
                                    <td>Total</td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(this.state.sumCapitalAMT) &&
                                            this.formatNumber(this.state.sumCapitalAMT)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table
                            className="table table-hover table-striped capital-table capital-year-table"
                            style={{ flex: 4 }}
                        >
                            <thead>
                                <tr>
                                    <td style={{ textAlign: "center", fontWeight: 700 }}>Scenario</td>
                                    <td style={{ textAlign: "center", fontWeight: 700 }}>
                                        {moment(this.state.selectedDate, "DD/MM/YYYY").year() + 1}%
                                    </td>
                                    <td style={{ textAlign: "center", fontWeight: 700 }}>
                                        {moment(this.state.selectedDate, "DD/MM/YYYY").year() + 2}%
                                    </td>
                                    <td style={{ textAlign: "center", fontWeight: 700 }}>
                                        {moment(this.state.selectedDate, "DD/MM/YYYY").year() + 3}%
                                    </td>
                                    <td style={{ textAlign: "center", fontWeight: 700 }}>
                                        Capital {moment(this.state.selectedDate, "DD/MM/YYYY").year() + 1}
                                    </td>
                                    <td style={{ textAlign: "center", fontWeight: 700 }}>
                                        Capital {moment(this.state.selectedDate, "DD/MM/YYYY").year() + 2}
                                    </td>
                                    <td style={{ textAlign: "center", fontWeight: 700 }}>
                                        Capital {moment(this.state.selectedDate, "DD/MM/YYYY").year() + 3}
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.capitalTbl.map(
                                    (row, index) =>
                                        index !== this.state.capitalTbl.length - 1 && (
                                            <tr>
                                                <td>
                                                    {this.state.calculated &&
                                                        this.isNotEmpty(row[4]) &&
                                                        this.formatNumber(row[4])}
                                                </td>
                                                <td>
                                                    {this.state.calculated && (
                                                        <input
                                                            type="number"
                                                            style={{ height: "30px" }}
                                                            className="form-control"
                                                            value={row[5]}
                                                            onChange={(event) =>
                                                                this.onCapitalInputChange(event, index, 5)
                                                            }
                                                        />
                                                    )}
                                                </td>
                                                <td>
                                                    {this.state.calculated && (
                                                        <input
                                                            type="number"
                                                            style={{ height: "30px" }}
                                                            className="form-control"
                                                            value={row[6]}
                                                            onChange={(event) =>
                                                                this.onCapitalInputChange(event, index, 6)
                                                            }
                                                        />
                                                    )}
                                                </td>
                                                <td>
                                                    {this.state.calculated && (
                                                        <input
                                                            type="number"
                                                            style={{ height: "30px" }}
                                                            className="form-control"
                                                            value={row[7]}
                                                            onChange={(event) =>
                                                                this.onCapitalInputChange(event, index, 7)
                                                            }
                                                        />
                                                    )}
                                                </td>
                                                <td>
                                                    {this.state.calculated &&
                                                        this.isNotEmpty(row[9]) &&
                                                        this.formatNumber(row[8])}
                                                </td>
                                                <td>
                                                    {this.state.calculated &&
                                                        this.isNotEmpty(row[9]) &&
                                                        this.formatNumber(row[9])}
                                                </td>
                                                <td>
                                                    {this.state.calculated &&
                                                        this.isNotEmpty(row[10]) &&
                                                        this.formatNumber(row[10])}
                                                </td>
                                            </tr>
                                        )
                                )}
                                <tr>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(this.state.sumCapitalSecenario) &&
                                            this.formatNumber(this.state.sumCapitalSecenario)}
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(this.state.sumCapitalT1) &&
                                            this.formatNumber(this.state.sumCapitalT1)}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(this.state.sumCapitalT2) &&
                                            this.formatNumber(this.state.sumCapitalT2)}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(this.state.sumCapitalT3) &&
                                            this.formatNumber(this.state.sumCapitalT3)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style={{ height: 20 }} />
                    <table className="table table-hover table-striped rwa-table">
                        <thead>
                            <tr>
                                <td style={{ fontWeight: 700 }}>RWA</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Credit Risk</td>
                                <td>EAD AMT</td>
                                <td>RW (%)</td>
                                <td>RWA AMT</td>
                                <td>EAD (%)</td>
                                <td>▲</td>
                                <td>RW (%)</td>
                                <td>▲</td>
                                <td>RWA (%)</td>
                                <td>EAD CHG</td>
                                <td>RW CHG</td>
                                <td>RWA CHG</td>
                                <td>{moment(this.state.selectedDate, "DD/MM/YYYY").year() + 1}%</td>
                                <td>{moment(this.state.selectedDate, "DD/MM/YYYY").year() + 2}%</td>
                                <td>{moment(this.state.selectedDate, "DD/MM/YYYY").year() + 3}%</td>
                                <td>RWA {moment(this.state.selectedDate, "DD/MM/YYYY").year() + 1}</td>
                                <td>RWA {moment(this.state.selectedDate, "DD/MM/YYYY").year() + 2}</td>
                                <td>RWA {moment(this.state.selectedDate, "DD/MM/YYYY").year() + 3}</td>
                            </tr>
                            {this.state.rwaTblTop.map((row, index) => (
                                <tr>
                                    <td style={{ paddingLeft: "2em" }}>{row[0]}</td>
                                    <td>{this.state.calculated && this.formatNumber(row[1])}</td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[2]) &&
                                            this.formatNumber(row[2])}
                                    </td>
                                    <td>{this.state.calculated && this.formatNumber(row[3])}</td>
                                    <td>
                                        {this.state.calculated && (
                                            <input
                                                type="number"
                                                style={{ height: "30px" }}
                                                className="form-control"
                                                value={row[4]}
                                                onChange={(event) => this.onRwaTopInputChange(event, index, 4)}
                                                readOnly={this.state.disabledInput[`${index}_4`] === true}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[5]) &&
                                            this.formatNumber(row[5])}
                                    </td>
                                    <td>
                                        {this.state.calculated && (
                                            <input
                                                type="number"
                                                style={{ height: "30px" }}
                                                className="form-control"
                                                value={row[6]}
                                                onChange={(event) => this.onRwaTopInputChange(event, index, 6)}
                                                readOnly={this.state.disabledInput[`${index}_6`] === true}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[7]) &&
                                            this.formatNumber(row[7])}
                                    </td>
                                    <td>
                                        {this.state.calculated && (
                                            <input
                                                type="number"
                                                style={{ height: "30px" }}
                                                className="form-control"
                                                value={row[8]}
                                                onChange={(event) => this.onRwaTopInputChange(event, index, 8)}
                                                readOnly={this.state.disabledInput[`${index}_8`] === true}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[9]) &&
                                            this.formatNumber(row[9])}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[10]) &&
                                            this.formatNumber(row[10])}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[11]) &&
                                            this.formatNumber(row[11])}
                                    </td>
                                    <td>
                                        {this.state.calculated && (
                                            <input
                                                type="number"
                                                style={{ height: "30px" }}
                                                className="form-control"
                                                value={row[12]}
                                                onChange={(event) => this.onRwaTopInputChange(event, index, 12)}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {this.state.calculated && (
                                            <input
                                                type="number"
                                                style={{ height: "30px" }}
                                                className="form-control"
                                                value={row[13]}
                                                onChange={(event) => this.onRwaTopInputChange(event, index, 13)}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {this.state.calculated && (
                                            <input
                                                type="number"
                                                style={{ height: "30px" }}
                                                className="form-control"
                                                value={row[14]}
                                                onChange={(event) => this.onRwaTopInputChange(event, index, 14)}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[15]) &&
                                            this.formatNumber(row[15])}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[16]) &&
                                            this.formatNumber(row[16])}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[17]) &&
                                            this.formatNumber(row[17])}
                                    </td>
                                </tr>
                            ))}
                            {this.state.rwaTblBottom.map((row, index) => (
                                <tr>
                                    <td>{row[0]}</td>
                                    <td>{this.state.calculated &&
                                        this.isNotEmpty(row[1]) &&
                                        this.formatNumber(row[1])}</td>
                                    <td></td>
                                    <td>{this.state.calculated && this.formatNumber(row[3])}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        {this.state.calculated && (
                                            <input
                                                type="number"
                                                style={{ height: "30px" }}
                                                className="form-control"
                                                value={row[8]}
                                                onChange={(event) => this.onRwaBottomInputChange(event, index, 8)}
                                            />
                                        )}
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[11]) &&
                                            this.formatNumber(row[11])}
                                    </td>
                                    <td>
                                        {this.state.calculated && (
                                            <input
                                                type="number"
                                                style={{ height: "30px" }}
                                                className="form-control"
                                                value={row[12]}
                                                onChange={(event) => this.onRwaBottomInputChange(event, index, 12)}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {this.state.calculated && (
                                            <input
                                                type="number"
                                                style={{ height: "30px" }}
                                                className="form-control"
                                                value={row[13]}
                                                onChange={(event) => this.onRwaBottomInputChange(event, index, 13)}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {this.state.calculated && (
                                            <input
                                                type="number"
                                                style={{ height: "30px" }}
                                                className="form-control"
                                                value={row[14]}
                                                onChange={(event) => this.onRwaBottomInputChange(event, index, 14)}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[15]) &&
                                            this.formatNumber(row[15])}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[16]) &&
                                            this.formatNumber(row[16])}
                                    </td>
                                    <td>
                                        {this.state.calculated &&
                                            this.isNotEmpty(row[17]) &&
                                            this.formatNumber(row[17])}
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <td>Total</td>
                                <td></td>
                                <td></td>
                                <td>
                                    {this.state.calculated &&
                                        this.isNotEmpty(this.state.totalRwa) &&
                                        this.formatNumber(this.state.totalRwa)}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                    {this.state.calculated &&
                                        this.isNotEmpty(this.state.sumRwaCHG) &&
                                        this.formatNumber(this.state.sumRwaCHG)}
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>
                                    {this.state.calculated &&
                                        this.isNotEmpty(this.state.sumRwaT1) &&
                                        this.formatNumber(this.state.sumRwaT1)}
                                </td>
                                <td>
                                    {this.state.calculated &&
                                        this.isNotEmpty(this.state.sumRwaT2) &&
                                        this.formatNumber(this.state.sumRwaT2)}
                                </td>
                                <td>
                                    {this.state.calculated &&
                                        this.isNotEmpty(this.state.sumRwaT3) &&
                                        this.formatNumber(this.state.sumRwaT3)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <Alert
                    title="Are you sure?"
                    show={this.state.showConfirmation}
                    showCancelButton
                    onConfirm={() => {
                        this.setState({ showConfirmation: false })
                        this.export()
                    }}
                    onCancel={() => {
                        this.setState({ showConfirmation: false })
                    }} />
            </div>
        );
    }
}

export default CapPlanningDetail;



// WEBPACK FOOTER //
// ./src/pages/CapitalPlanning/Dashboard/index.js